/**
 * Reduces a doc-list column filter value to the values a Firestore where clause can carry.
 *
 * Consumed by `homePageStateFns` when it builds the server `where` array and when it
 * decides whether a column filter counts as an extra server filter. It lives beside the
 * doc-list column code rather than inside the orchestrator's `@internal` module because
 * the blank sentinels it strips are the table's, not the orchestrator's.
 *
 * A non-array value is treated as a single-value list. Nulls, empty strings and the
 * two blank sentinels — `INCLUDE_BLANKS_VALUE` and `REMOVE_BLANKS_VALUE` — are UI-only
 * markers with no Firestore meaning, so they are stripped.
 */
import { INCLUDE_BLANKS_VALUE, REMOVE_BLANKS_VALUE } from './DocListTable/constants';

export function cleanFilterValues(value: unknown): unknown[] {
  const values = Array.isArray(value) ? value : [value];
  return values.filter(
    (v) =>
      v !== null &&
      v !== undefined &&
      String(v) !== '' &&
      String(v) !== INCLUDE_BLANKS_VALUE &&
      String(v) !== REMOVE_BLANKS_VALUE
  );
}
